import React from 'react';
import PropTypes from 'prop-types';
import {Font} from '@pepsico-ds/ui';

const TargetTypeLabel = ({value}) => (
  <section className='mb-4'>
    <Font size='xsmall'>Target Type</Font>
    <section>
      <Font size='body' style={{fontWeight: 'bold'}}>
        {value}
      </Font>
    </section>
  </section>
);

TargetTypeLabel.propTypes = {
  value: PropTypes.string
};

export default TargetTypeLabel;
